import * as Token from './Token';
export const textWeightRegularStyle = {
    fontFamily: 'MuseoSans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    fontWeight: '500',
};
export const textWeightMediumStyle = {
    fontFamily: 'MuseoSans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    fontWeight: '700',
};
export const textWeightBoldStyle = {
    fontFamily: 'MuseoSans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    fontWeight: '900',
};
export const elevation = {
    container: {
        shadowColor: Token.color.uiDarkPrimary,
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: Token.opacity.seeThrough(),
        shadowRadius: 2,
    },
    // interactive is deprecated. Use raised instead
    interactive: {
        shadowColor: Token.color.uiDarkPrimary,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: Token.opacity.clear(),
        shadowRadius: 5,
    },
    raised: {
        shadowColor: Token.color.uiDarkPrimary,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: Token.opacity.clear(),
        shadowRadius: 5,
    },
    float: {
        shadowColor: Token.color.uiDarkPrimary,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: Token.opacity.clear(),
        shadowRadius: 10,
    },
    hover: {
        shadowColor: Token.color.uiDarkPrimary,
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: Token.opacity.seeThrough(),
        shadowRadius: 16,
    },
};
